const KeenSlider = window.KeenSlider

const { setInitialised, useAutoplay, useDots } = window.BAO.Carousel.plugins

class PressCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['dot', 'dots-slider']
  }

  connectedCallback () {
    super.connectedCallback()

    this.dotCarousel = this.initialiseDotCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.handleDotClick = this.handleDotClick.bind(this)

    this.els.dot.elements.forEach((dot) =>
      this.listeners.add(dot, 'click', this.handleDotClick),
    )
  }

  initialiseDotCarousel () {
    const itemCount = this.els.dot.elements.length

    return new KeenSlider(
      this.els['dots-slider'].element,
      {
        loop: true,
        slides: {
          origin: 'center',
          perView: 2,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              origin: 'center',
              perView: 3,
            },
            disabled: itemCount <= 3,
          },
          '(min-width: 1201px)': {
            slides: {
              origin: 'center',
              perView: 5,
            },
            disabled: itemCount <= 5,
          },
        },
      },
      [
        setInitialised(),
        useDots(this.els?.bar?.elements),
        useAutoplay(this.autoplaySpeed, { pauseOnHover: false }),
        (carousel) => {
          carousel.on('animationStarted', () => {
            const nextActiveIndex = carousel.track.absToRel(
              carousel.animator.targetIdx || 0,
            )

            carousel.slides.forEach((slide, index) => {
              slide.setAttribute('aria-current', index === nextActiveIndex)
            })

            this.activeIndex = nextActiveIndex
          })

          const updateDisabledClass = () => {
            if (carousel.options.disabled) {
              this.els['dots-slider'].element.classList.add(
                'sec-Press_DotsList-disabled',
              )
            } else {
              this.els['dots-slider'].element.classList.remove(
                'sec-Press_DotsList-disabled',
              )
            }
          }

          updateDisabledClass()
          carousel.on('optionsChanged', updateDisabledClass)
        },
      ],
    )
  }

  /** @param {PointerEvent} event */
  handleDotClick (event) {
    const dotIndex = this.els.dot.elements.indexOf(event.currentTarget)

    this.activeIndex = dotIndex

    this.dotCarousel.moveToIdx(dotIndex)
  }

  /** @returns {number} */
  get activeIndex () {
    return this.els?.item?.elements.findIndex(
      (item) => item.getAttribute('aria-current') === 'true',
    )
  }

  set activeIndex (activeIndex) {
    this.els?.item?.elements.forEach((item, index) => {
      item.setAttribute('aria-current', activeIndex === index)
    })
  }

  get autoplaySpeed () {
    return Number(this.getAttribute('autoplay-speed'))
  }
}

if (!window.customElements.get('press-carousel')) {
  window.customElements.define('press-carousel', PressCarousel)
}
